<template>
  <div v-if="device.config != null">
    <!-- Tabs with card integration -->
    <b-form @submit.prevent="reRender()">
      <!-- <pre>index: {{this.device.config.profile.default}} </pre> -->
      <b-card no-body>
        <b-tabs pills v-model="tabIndex" small card>
          <b-tab title="System">
            <system :device="device" :account_opts="account_opts" :changed="changed" :changes="changes"></system>
          </b-tab>
          <b-tab title="WAN">
            <wan :device="device" :changed="changed" :changes="changes"></wan>
          </b-tab>
          <b-tab title="LTE" v-if="device.config.profile.default != 0">
            <lte :device="device" :changed="changed" :changes="changes"></lte>
          </b-tab>
          <b-tab title="LAN">
            <lan :device="device" :changed="changed" :changes="changes"></lan>
          </b-tab>
          <b-tab title="Wireless">
            <wifi :device="device" :changed="changed" :changes="changes"></wifi>
          </b-tab>





          <!--           <b-tab title="VoIP">
            <voip></voip>
          </b-tab>
          <b-tab title="Firewall" disabled>Use v-if</b-tab> -->
                <b-tab title="Services" v-if="device.config.TRL != null">
                    <services :device="device" :changed="changed" :changes="changes"></services>
                </b-tab>

        </b-tabs>
      </b-card>
    </b-form>
  </div>
    <div v-else>
      No data for this device
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import WAN from "@/readynet/devices/network/Wan";
import LAN from "@/readynet/devices/network/Lan";
// import VOIP from "@/readynet/devices/network/Voip";
import Wifi from "@/readynet/devices/network/Wireless";
import System from "@/readynet/devices/network/System";
import LTE from "@/readynet/devices/network/LTE";
import Services from "@/readynet/devices/network/Services";

export default {
  components: {
    Multiselect,
    'wan': WAN,
    'lan': LAN,
    'wifi': Wifi,
    'system': System,
    'lte': LTE,
   Services,
    // 'voip': VOIP,
  },

  props: {
    device: {
      type: Object,
      default: function() {
        return {}
      }
    },
    account_opts: {
      type: Object,
      default: function() {
        return {}
      }
    },
    changed: {
      type: Array,
      // default: () =>([]),
    },
    changes: {
      type: Object,
      // default: () =>([]),
    },
  },

  data() {
    return {
      tabIndex: 0
    }
  },

  mounted() {
    // console.log(this.params)
  },
  methods: {
    reRender() {
      this.$forceUpdate()
    }
  },

  onSubmit() {},

}
</script>
